import type { AxiosInstance, AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import axios from 'axios';

class HttpClient {
  private readonly axios: AxiosInstance;

  constructor(baseURL: string, config?: AxiosRequestConfig) {
    this.axios = axios.create({
      baseURL,
      ...config,
      withCredentials: true,
    });

    this.axios.interceptors.request.use(
      (config) => {
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    this.axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (axios.isCancel(error)) {
          //  请求已取消
        } else {
          //  请求失败
        }

        return Promise.reject(error);
      }
    );
  }

  addRequestInterceptor(
    successHandler: (config: InternalAxiosRequestConfig<any>) => InternalAxiosRequestConfig<any>,
    errorHandler: (error: any) => any = (error) => error
  ) {
    //  添加请求拦截器
    this.axios.interceptors.request.use(successHandler, errorHandler);
  }

  addResponseInterceptor(
    successHandler: (response: any) => any,
    errorHandler: (error: any) => any = (error) => error
  ) {
    //  添加响应拦截器
    this.axios.interceptors.response.use(successHandler, errorHandler);
  }

  public async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.axios.get<T>(url, config);
    return response.data;
  }

  public async post<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
    origin?: boolean
  ): Promise<T> {
    const response = await this.axios.post<T>(url, data, config);
    if (origin) {
      return response as T;
    }
    return response.data;
  }

  public async put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.axios.put<T>(url, data, config);
    return response.data;
  }

  public async delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.axios.delete<T>(url, config);
    return response.data;
  }
}

export const defaultConfig: AxiosRequestConfig = {
  timeout: 100 * 1000,
  headers: {
    'Content-type': 'application/json',
  },
};

export default HttpClient;
